export type StatusType = 0 | 1 | 2 | -1 | -2;
export const STATUS_INITIAL: StatusType = 0;
export const STATUS_PENDING: StatusType = 1;
export const STATUS_SUCCESS: StatusType = 2;
export const STATUS_ERROR: StatusType = -1;
export const STATUS_NOT_FOUND: StatusType = -2;

export const LOCATION_TRACKING_TYPES = {
  GPS: 'GPS',
  IP: 'IP',
};

export const CACHE_KEYS = {
  LOCATION: {
    APPROVED_LOCATIONS: 'approved_locations',
  },
};

export const AB_TEST_COOKIE_NAME = 'AB_TEST';
export const AB_TEST_STOREFRONT_VALUE = 'storefront';

export enum BOOKING_STATUS {
  ACCEPTED = 'ACCEPTED',
  DELETED = 'DELETED',
  TIMEDOUT = 'TIMEDOUT',
  REJECTED = 'REJECTED',
  RESERVATION = 'RESERVATION',
  CANCELLEDBYHOST = 'CANCELLEDBYHOST',
  CANCELLEDBYADMIN = 'CANCELLEDBYADMIN',
  CANCELLEDBYGUEST = 'CANCELLEDBYGUEST',
  CANCELLEDBYCOUPON = 'CANCELLEDBYCOUPON',
  CANCELLEDBYHOSTNOSHOW = 'CANCELLEDBYHOSTNOSHOW',
  EXPIRED = 'EXPIRED',
  PROPOSAL = 'PROPOSAL',
  PAIDPROPOSAL = 'PAIDPROPOSAL',
  UNCONFIRMED = 'UNCONFIRMED',
  CONFIRMED = 'CONFIRMED',
  COMPLETED = 'COMPLETED',
  TRANSFER_REQUESTED = 'TRANSFER_REQUESTED',
}

export const UNBOOKABLE_STATUS = [
  BOOKING_STATUS.DELETED,
  BOOKING_STATUS.TIMEDOUT,
  BOOKING_STATUS.REJECTED,
  BOOKING_STATUS.CANCELLEDBYHOST,
  BOOKING_STATUS.CANCELLEDBYADMIN,
  BOOKING_STATUS.CANCELLEDBYGUEST,
  BOOKING_STATUS.CANCELLEDBYCOUPON,
  BOOKING_STATUS.EXPIRED,
];
export const ALREADY_BOOKED_STATUS = [
  BOOKING_STATUS.UNCONFIRMED,
  BOOKING_STATUS.PAIDPROPOSAL,
  BOOKING_STATUS.CONFIRMED,
  BOOKING_STATUS.COMPLETED,
];

export const CONSENT_COOKIES_KEYS = {
  CONSENT_SAVED: 'wl-consent-saved',
  ADVERTISEMENT: 'wl-consent-advertisement',
  ANALYTICS: 'wl-consent-analytics',
  PERSONALISED_ADS: 'wl-consent-personalised_ads',
  SOCIAL: 'wl-consent-social',
  LOCATION: 'wl-consent-location',
};

export const EXPERIENCE_STATUS = {
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  DELETED: 'DELETED',
  NEW: 'NEW',
};

export const ITINERARY_PROPOSITION_STATUS = {
  PUBLISHED: 'Published',
  UNPUBLISHED: 'Unpublished',
  REMOVED: 'Removed',
  DRAFT: 'Draft',
};

export const HOST_STATUS = {
  ACTIVE: 'Active',
  OUT_OF_OFFICE: 'OutOfOffice',
  INACTIVE: 'Inactive',
  ONBOARDING: 'Onboarding',
  INITIAL: 'Initial',
};

export const STATUS_COLOR = {
  online: 'green',
  away: 'orange',
  offline: 'red',
  suspended: 'red',
} as const;

export const LANDING_PAGE_SEARCH_PARAMS = ['lp', 'mcid', 'gclid', 'msclkid'];
export const TOP_SEARCHES_EXPERIENCE_ID = 'iframe_experience_id';
export const LANDING_PAGE_DYNAMIC_TITLE_PARAM = 'k';

export const FOOD_RELATED_FILTERS = [
  'home-dinners',
  'cooking-classes',
  'food-drink-tastings',
  'wine-beer-tours',
  'food-tours',
];

export const PREMIUM_CITIES = [
  'porto',
  'istanbul',
  'bruges',
  'brussels',
  'naples',
  'venice',
  'chiang mai',
  'cape town',
  'palma de mallorca',
  'bali',
  'dubrovnik',
  'krakow',
  'warsaw',
  'kyoto',
  'copenhagen',
  'seoul',
  'dublin',
  'edinburgh',
];

export const EXP_SEARCH_PAGE_SIZE = 15;

export const GUEST_DEFAULT_PHOTO =
  'https://withlocals-com-res.cloudinary.com/image/upload/v1550848581/website/avatar/default-user.png';

export const GUEST_DEFAULT_PHOTOS = [
  GUEST_DEFAULT_PHOTO,
  'https://withlocals-com-res.cloudinary.com/image/upload/v1458736686/9b3476a82d45e28cafba1a16dc0a0516.png',
];

export const APPSTORE_LINK = 'https://apps.apple.com/us/app/id655695313';
export const PLAYSTORE_LINK =
  'https://play.google.com/store/apps/details?id=com.withlocals.Withlocals';
export const BUY_A_GIFT_VOUCHER_LINK =
  'https://giftup.app/place-order/9eeeca52-42dc-4e48-f9c3-08dab8104ad7?platform=hosted';

export const TIERS = {
  FOOD: 'food',
  ATTRACTIONS: 'attractions',
  DAY_TRIPS: 'day-trips',
  CITY: 'city',
};

export const CONCEPTS = {
  DAY_TRIP_FOOD: 'Day Trip Food & Drink',
  LAYOVER_CITY_WALK: 'Layover City walk',
  BREAKFAST: 'Breakfast tour',
  LAYOVER: 'Layover',
  FAST_FOOD: 'Fast Food',
  STL_COMBINATION: 'Skip the Line - Combination',
  TEN_TASTINGS: '10 Tastings',
  YOUR_FOODIE_WAY: 'Your Foodie Way',
  HHG: 'HHG',
  DRINKS_BITES: 'Drinks&Bites',
  OFF_THE_BEATEN_TRACK: 'Off the Beaten Track',
  FOOD_WITH_KIDS: 'Food with Kids',
  FOOD_CULTURE: 'Food & Culture',
  DAY_TRIP_AREA: 'Day Trip Area-Region',
  VIP_GOURMET_TOUR: 'VIP Gourmet Tour',
  BIKE_BITES: 'Bike & Bites',
  KICKSTART: 'Kickstart',
  WITHLOCALS_THREESIXTY: 'Withlocals 360',
  DAY_TRIP_OTHER_CITY: 'Day Trip Neighbouring City',
  STL_HIDDEN_GEMS: 'Skip the Line + Hidden Gems',
  YOUR_WAY: 'Your Way',
  STL_EXPRESS: 'Skip the Line Express',
  CITY_BY_BIKE: 'City by Bike',
  CITY_BY_NIGHT: 'City by Night',
  DAY_TRIP_ATTRACTION: 'Day Trip Attraction',
  STL_BY_NIGHT: 'Skip the Line by Night',
  CULTURE_OF_CITY: 'Culture of City',
  STL_FOR_EARLY_BIRDS: 'Skip the Line for Early Birds',
  HISTORY_OF_CITY: 'History of City',
  CROSS_CITY: 'Cross City (Traveling independently)',
  CITY_WITH_KIDS: 'City with Kids',
};

export enum CONTACT_HOST_SOURCES {
  HOST_PAGE = 'host_page',
  EXPERIENCE_PAGE = 'experience_page',
  LOCAL_PICKER = 'local_picker',
}

export enum PLATFORMS {
  WEB = 'web',
  PIZZA = 'pizza',
  CORDOVA = 'cordova',
  SERVER = 'server',
}

export const LINK_TO_CANCELLATION_POLICY =
  'https://support.withlocals.com/hc/en-us/articles/360005250333-What-is-the-Withlocals-cancellation-policy';

export const HOST_LICENSE_ENABLE_EDIT_BEFORE = new Date('2025-07-12');
